import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import { Row, Col, Button, Translate, Spinner } from '$common';
import style from './create.scss';
import { FadeInRight } from 'animate-components';

@CSSModules(style, { allowMultiple: true })
export default class ProjectSummary extends Component {
  render() {
    const { data, onClose, questionCount, totalAmount, isOpen, formIsSubmitting } = this.props;

    return data ? (
      <div styleName={`summary ${isOpen ? 'active' : ''}`}>
        <Row>
          <Col md="2/3">
            <h1>Task Summary</h1>
          </Col>
          <Col md="1/3">
            <a onClick={ () => onClose() } styleName="close"><img src={require('$shared/images/times.svg')}/></a>
          </Col>
        </Row>
        <br />
        <ul>
          <li><strong>{Translate.get('title')}:</strong> {data.name}</li>
          <li><strong>{Translate.get('quota_title')}:</strong> {data.max_submission_count}</li>
          <li><strong>{Translate.get('brief')}:</strong> {data.short_description || data.short_description_1 + ' ' + data.short_description_2 + ' ' + data.short_description_3}</li>
          <li><strong>{Translate.get('question_count')}:</strong> {questionCount}</li>
        </ul>
        <h2>{Translate.get('total_amount')}: {totalAmount}</h2>
        {
          questionCount > 0 && typeof data !== "undefined" ?
            formIsSubmitting ?
              <div style={{ textAlign: 'center', padding: '15px' }}><Spinner block center /> <br /> {Translate.get('submitting_button')}</div>
            : 
              <Button type="success" submit block>{Translate.get('submit')}</Button>
          : ''
        }
      </div>
    ) : ''
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/create/project-summary.js